import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import { fetchCohorts, toggleCohortSelected, toggleCohortsPresentation } from '../actions';

const CohortsPanelContainer = ({
  canRead,
  children,
  className,
  readErrors,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-cohorts-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions } },
  cohorts: { cohorts, newCohortCode },
}, { category, displayAs }) => {
  const item = cohorts[category];
  return {
    allowStatus: permissions.requests.create,
    canCreate: permissions.cohorts.create,
    canRead: permissions.cohorts.read,
    cohorts: item.results,
    currentPage: item.currentPage,
    display: displayAs || item.display,
    newCohortCode,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    total: item.count,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchCohorts,
  onCheckBoxClick: toggleCohortSelected,
  togglePresentation: toggleCohortsPresentation,
};

export default CohortsPanelContainer;
